import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';

const stateHandlers = {
    [constant.ListLoading](state, action) {
        return { ...state, loading: action.payload };
    },
};

const listHandlers = {
    [constant.GetList](state, action) {
        return action.payload;
    },
};

const listOldHandlers = {
    [constant.GetListOld](state, action) {
        return action.payload;
    },
};

const serverInfoHandlers = {
    [constant.SERVERINFO](state, action) {
        return action.payload;
    },
};

const hostHandlers = {
    [constant.GETHOST](state, action) {
        return action.payload;
    },
};
const setIpListHandlers = {
    [constant.IPLIST](state, action) {
        return action.payload;
    },
};
const statusHandlers = {
    [constant.CHANGESTATUS](state, action) {
        return action.payload;
    },
};

const bulkStatusHandlers = {
    [constant.CHANGEBULKSTATUS](state, action) {
        return action.payload;
    },
};

const addListStatusHandlers = {
    [constant.CHANGEADDLISTSTATUS](state, action) {
        return action.payload;
    },
};

const addWorkListStatusHandlers = {
    [constant.CHANGEADDWORKLISTSTATUS](state, action) {
        return action.payload;
    },
};

const serverStatusHandlers = {
    [constant.SERVERSTATUS](state, action) {
        return action.payload;
    },
};

const pageTotalHandlers = {
    [constant.PAGETOTAL](state, action) {
        return {...state, ...action.payload};
    },
};

const searchHandlers = {
    [constant.SEARCH](state, action) {
        return action.payload;
    },
};
const todayDelHandlers = {
    [constant.GETTODAYM](state, action) {
        return action.payload;
    },
};
const tomorrowAddHandlers = {
    [constant.GETTOMORROWM](state, action) {
        return action.payload;
    },
};
const delTodayHandlerStatus = {
    [constant.GETTODAYMSTATUS](state, action) {
        return action.payload;
    },
}
const addTomorrowHandersStatus = {
    [constant.GETTOMORROWMSTATUS](state, action) {
        return action.payload;
    },
}
export const todayDel = createReducer(false, todayDelHandlers);
export const tomorrowAdd = createReducer(false, tomorrowAddHandlers);
export const todayDelStatus = createReducer(false, delTodayHandlerStatus);
export const tomorrowAddStatus = createReducer(false, addTomorrowHandersStatus);
export const ListStatus = createReducer({ loading: false }, stateHandlers); // 列表状态
export const ListHost = createReducer([], listHandlers); // 列表
export const ListHostOld = createReducer([], listOldHandlers); // 列表
export const Host = createReducer({}, hostHandlers);
export const Status = createReducer(0, statusHandlers);
export const bulkStatus = createReducer(false, bulkStatusHandlers);
export const addListStatus = createReducer(false, addListStatusHandlers);
export const addWorkListStatus = createReducer(false, addWorkListStatusHandlers);
export const ipList = createReducer([], setIpListHandlers); // 设置弹层传递的taskIdList
// export const searchActiveListGet = createReducer([], Activehandlers);// 查询活动条件列表
export const serverInfo = createReducer({}, serverInfoHandlers);
export const serverStatus = createReducer({showServe: false}, serverStatusHandlers);
export const pageTotal = createReducer({total: 0, page: 1, pageSize: 10}, pageTotalHandlers);
export const searchData = createReducer({}, searchHandlers);

export const hostList = combineReducers({
    bulkStatus,
    addListStatus,
    addWorkListStatus,
    ipList,
    Status,
    Host,
    ListHost,
    ListStatus,
    serverInfo,
    serverStatus,
    ListHostOld,
    pageTotal,
    searchData,
    todayDel,
    tomorrowAdd,
    todayDelStatus,
    tomorrowAddStatus,
});



// WEBPACK FOOTER //
// ./pages/assist/hostManage/reducers.js